/*
 * @Description: 工具集
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-09-01 01:13:39
 * @LastEditors: Monkey
 * @LastEditTime: 2025-07-08 12:23:36
 */

import sysConfig from '@/config';
import CryptoJS from 'crypto-js';
import { ElNotification } from 'element-plus';

const tool = {};

/* localStorage */
tool.data = {
  set(key, data, datetime = 0) {
    //加密
    if (sysConfig.LS_ENCRYPTION == 'AES') {
      data = tool.crypto.AES.encrypt(JSON.stringify(data), sysConfig.LS_ENCRYPTION_key);
    }
    let cacheValue = {
      content: data,
      datetime: parseInt(datetime) === 0 ? 0 : new Date().getTime() + parseInt(datetime) * 1000,
    };
    return localStorage.setItem(key, JSON.stringify(cacheValue));
  },
  get(key) {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (value) {
        let nowTime = new Date().getTime();
        if (nowTime > value.datetime && value.datetime != 0) {
          localStorage.removeItem(key);
          return null;
        }
        //解密
        if (sysConfig.LS_ENCRYPTION == 'AES') {
          value.content = JSON.parse(
            tool.crypto.AES.decrypt(value.content, sysConfig.LS_ENCRYPTION_key)
          );
        }
        return value.content;
      }
      return null;
    } catch (err) {
      return null;
    }
  },
  remove(key) {
    return localStorage.removeItem(key);
  },
  clear() {
    return localStorage.clear();
  },
};

/*sessionStorage*/
tool.session = {
  set(table, settings) {
    var _set = JSON.stringify(settings);
    return sessionStorage.setItem(table, _set);
  },
  get(table) {
    var data = sessionStorage.getItem(table);
    try {
      data = JSON.parse(data);
    } catch (err) {
      return null;
    }
    return data;
  },
  remove(table) {
    return sessionStorage.removeItem(table);
  },
  clear() {
    return sessionStorage.clear();
  },
};

/*cookie*/
tool.cookie = {
  set(name, value, config = {}) {
    var cfg = {
      expires: null,
      path: null,
      domain: null,
      secure: false,
      httpOnly: false,
      ...config,
    };
    var cookieStr = `${name}=${escape(value)}`;
    if (cfg.expires) {
      var exp = new Date();
      exp.setTime(exp.getTime() + parseInt(cfg.expires) * 1000);
      cookieStr += `;expires=${exp.toGMTString()}`;
    }
    if (cfg.path) {
      cookieStr += `;path=${cfg.path}`;
    }
    if (cfg.domain) {
      cookieStr += `;domain=${cfg.domain}`;
    }
    document.cookie = cookieStr;
  },
  get(name) {
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
    if (arr != null) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  remove(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    document.cookie = `${name}=;expires=${exp.toGMTString()}`;
  },
};

/* Fullscreen */
tool.screen = function (element) {
  var isFull = !!(
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement ||
    document.fullscreenElement
  );
  if (isFull) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  } else {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    }
  }
};

/* 复制对象 */
tool.objCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

/* 日期格式化 */
tool.dateFormat = function (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  date = new Date(date);
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};

/* 千分符 */
tool.groupSeparator = function (num) {
  num = num + '';
  if (!num.includes('.')) {
    num += '.';
  }
  return num
    .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
      return $1 + ',';
    })
    .replace(/\.$/, '');
};

/* 随机数 */
tool.randomString = function (len) {
  len = len || 32;
  /** 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1 */
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

/* 将参数生成标准格式并排序 */
tool.paramsStrSort = function (paramsStr) {
  // 将参数分解为键值对并自定义排序
  const paramPairs = paramsStr.split('&').map(pair => {
    const [key] = pair.split('=');
    return { key: key.replace(/\\/g, ''), pair };
  });

  paramPairs.sort((a, b) => {
    // 数字键按数值排序
    if (!isNaN(a.key) && !isNaN(b.key)) {
      return parseInt(a.key) - parseInt(b.key);
    }
    // 非数字键按字母顺序排序
    return a.key.localeCompare(b.key);
  });

  const sortedStr = paramPairs.map(p => p.pair).join('&');
  const sign = tool.crypto.MD5(sortedStr);
  if (process.env.NODE_ENV === 'development') {
    console.log(sortedStr);
    console.log(sign);
  }
  return sign;
};

/* 签名 */
tool.sign = function (params) {
  if (typeof params === 'string') {
    return tool.paramsStrSort(params);
  } else if (typeof params === 'object') {
    var arr = [];
    for (var i in params) {
      let paramsVal = typeof params[i] === 'object' ? JSON.stringify(params[i]) : params[i];
      if (paramsVal !== undefined && paramsVal !== null && paramsVal !== 'null') {
        arr.push(i + '=' + paramsVal);
      }
    }
    return tool.paramsStrSort(arr.join('&'));
  }
};

/* 常用加解密 */
tool.crypto = {
  //MD5加密
  MD5(data) {
    return CryptoJS.MD5(data).toString();
  },
  //BASE64加解密
  BASE64: {
    encrypt(data) {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
    },
    decrypt(cipher) {
      return CryptoJS.enc.Base64.parse(cipher).toString(CryptoJS.enc.Utf8);
    },
  },
  //AES加解密
  AES: {
    encrypt(data, secretKey, config = {}) {
      if (secretKey.length % 8 != 0) {
        console.warn('[SCUI error]: 秘钥长度需为8的倍数，否则解密将会失败。');
      }
      const result = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(secretKey), {
        iv: CryptoJS.enc.Utf8.parse(config.iv || ''),
        mode: CryptoJS.mode[config.mode || 'ECB'],
        padding: CryptoJS.pad[config.padding || 'Pkcs7'],
      });
      return result.toString();
    },
    decrypt(cipher, secretKey, config = {}) {
      const result = CryptoJS.AES.decrypt(cipher, CryptoJS.enc.Utf8.parse(secretKey), {
        iv: CryptoJS.enc.Utf8.parse(config.iv || ''),
        mode: CryptoJS.mode[config.mode || 'ECB'],
        padding: CryptoJS.pad[config.padding || 'Pkcs7'],
      });
      return CryptoJS.enc.Utf8.stringify(result);
    },
  },
};

/* 把对象中的null转换成字符串'' */
tool.null2str = function (data) {
  for (let k in data) {
    if (data[k] === null) {
      data[k] = '';
    } else {
      if (Array.isArray(data[k])) {
        // 是数组则便利数组，递归处理
        data[k] = data[k].map((z) => {
          return tool.null2str(z);
        });
      }
      if (typeof data[k] === 'object') {
        // 是json 递归处理
        data[k] = tool.null2str(data[k]);
      }
    }
  }
  return data;
}

/* 通过身份证验证计算年龄和性别 */
tool.analyzeIDCard = (userCard, idAreaData) => {
  let sexAndAge = {}
  // 如果身份证号码为空，则返回空
  const regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (!userCard || !regIdNo.test(userCard)) {
    return sexAndAge
  }
  // 获取地址
  let area = userCard.substring(0, 6)
  sexAndAge.area = idAreaData[area]

  // 获取性别
  if (parseInt(userCard.substr(16, 1)) % 2 === 1) {
    sexAndAge.sex = '1' // 男
  } else {
    sexAndAge.sex = '2' // 女
  }
  // 获取出生年月日
  // userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
  let yearBirth = userCard.substring(6, 10)
  let monthBirth = userCard.substring(10, 12)
  let dayBirth = userCard.substring(12, 14)
  // 获取当前年月日并计算年龄
  let myDate = new Date()
  let monthNow = myDate.getMonth() + 1
  let dayNow = myDate.getDay()
  let age = myDate.getFullYear() - yearBirth
  if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
    age--
  }
  // 得到年龄
  sexAndAge.age = age
  // 生日
  sexAndAge.birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
  // 返回性别和年龄
  return sexAndAge
}

/* 小写数字转大写金额 */
tool.smalltoBIG = (n) => {
  var fraction = ['角', '分']
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  var head = n < 0 ? '欠' : ''
  n = Math.abs(n)

  var s = ''

  for (var i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    var p = ''
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

/**
 * 金额格式化工具函数
 * @param {Number|String} amount 原始金额（数字或数字字符串）
 * @param {String} symbol 货币符号（默认：¥）
 * @param {Number} decimalDigits 小数位数（默认：2）
 * @returns {String} 格式化后的金额字符串（如：¥12,345.67）
 */
tool.formatCurrency = (amount, symbol = '¥', decimalDigits = 2) => {
  // 处理空值或非数字情况
  if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return symbol + '0.' + '0'.repeat(decimalDigits);
  }

  // 转换为数字并保留指定小数位
  const num = Number(amount);
  const fixedNum = num.toFixed(decimalDigits); // 如 12345.67 → "12345.67"

  // 分割整数和小数部分
  const [integerPart, decimalPart] = fixedNum.split('.');

  // 整数部分添加千分位分隔符
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 拼接结果（货币符号 + 格式化整数 + 小数点 + 小数部分）
  return `${symbol}${formattedInteger}.${decimalPart}`;
}

/**
 * 百分比格式化工具函数
 * @param {Number|String} percent 原始百分比（小数，如 0.85 → 85%）
 * @param {Number} decimalDigits 小数位数（默认：2）
 * @returns {String} 格式化后的百分比字符串（如：85.00%）
 */
tool.formatPercent = (percent, decimalDigits = 2) => {
  // 处理空值或非数字情况
  if (percent === null || percent === undefined || isNaN(Number(percent))) {
    return '0.' + '0'.repeat(decimalDigits) + '%';
  }

  // 转换为百分比并保留指定小数位（小数 × 100）
  const num = Number(percent) * 100;
  const fixedNum = num.toFixed(decimalDigits); // 如 0.852 → 85.20

  return `${fixedNum}%`;
}

/** 创建autocomplete搜索的数据 */
tool.createSearchList = (datalist, query, key) => {
  const list = []
  datalist.forEach(item => {
    let value
    switch (key) {
      case 'product':
        value = item.name + '-' + item.day + '天' + (item.code === '' ? '' : '（' + item.code + '）')
        break
      case 'hotelStar':
        value = item.dicName
        break
      case 'messageForm':
      case 'shuttle':
        value = item.message
        break
      case 'vehicle':
        value = item.carNumber
        if (item.driver !== '') {
          value += ('(' + item.driver + ')')
        }
        break
      default:
        value = item.name
        break
    }

    if (query === '' || (item.name !== undefined && item.name.indexOf(query) !== -1)) {
      list.push({
        label: item.id,
        value: value
      })
    }
  })
  return list
}

/** 日期大小比较 */
tool.compareDate = (d1, d2) => {
  return ((new Date(d1.replace(/-/g, "/"))) > (new Date(d2.replace(/-/g, '/'))))
}
tool.calcDay = (timestamp1, timestamp2) => {
  const d1 = Date.parse(new Date(timestamp1.replace(/-/g, '/')))
  const d2 = Date.parse(new Date(timestamp2.replace(/-/g, '/')))
  return parseInt((d2 - d1) / (1000 * 60 * 60 * 24)) // 核心：时间戳相减，然后除以天数
}
tool.getTimestampFromYearMonth = (yearMonth) => {
  const [year, month] = yearMonth.split('-');
  const date = new Date(year, parseInt(month) - 1, 1, 0, 0, 0);
  return date.getTime();
}
tool.formatTimeDiff = (startTimestamp, endTimestamp) => {
  const diff = endTimestamp - startTimestamp;
  const oneSecond = 1000;
  const oneMinute = oneSecond * 60;
  const oneHour = oneMinute * 60;
  const oneDay = oneHour * 24;
  const oneMonth = oneDay * 30;
  const oneYear = oneMonth * 12;

  if (diff < oneMinute) {
    const seconds = Math.floor(diff / oneSecond);
    return `${seconds}秒`;
  } else if (diff < oneHour) {
    const minutes = Math.floor(diff / oneMinute);
    const remainingSeconds = Math.floor((diff % oneMinute) / oneSecond);
    if (remainingSeconds === 0) {
      return `${minutes}分`;
    }
    return `${minutes}分${remainingSeconds}秒`;
  } else if (diff < oneDay) {
    const hours = Math.floor(diff / oneHour);
    const remainingMinutes = Math.floor((diff % oneHour) / oneMinute);
    if (remainingMinutes === 0) {
      return `${hours}小时`;
    }
    return `${hours}小时${remainingMinutes}分`;
  } else if (diff < oneMonth) {
    const days = Math.floor(diff / oneDay);
    const remainingHours = Math.floor((diff % oneDay) / oneHour);
    if (remainingHours === 0) {
      return `${days}天`;
    }
    return `${days}天${remainingHours}小时`;
  } else if (diff < oneYear) {
    const months = Math.floor(diff / oneMonth);
    const remainingDays = Math.floor((diff % oneMonth) / oneDay);
    if (remainingDays === 0) {
      return `${months}个月`;
    }
    return `${months}个月${remainingDays}天`;
  } else {
    const years = Math.floor(diff / oneYear);
    const remainingMonths = Math.floor((diff % oneYear) / oneMonth);
    if (remainingMonths === 0) {
      return `${years}年`;
    }
    return `${years}年${remainingMonths}个月`;
  }
}

/** notify提醒 */
tool.notify = {
  error: (options) => ElNotification.error(options),
  success: (options) => ElNotification.success(options),
  warning: (options) => ElNotification.warning(options),
  info: (options) => ElNotification.info(options),
}

/** uuid */
tool.uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/** 附件相关工具 */
tool.attachment = {
  // 转换视频和图片
  covert(list, dataList) {
    dataList.forEach(item => {
      list.push({
        fileId: item.fileId, // 附件id，用于删除附件AP
        fileName: item.fileName,
        filePath: item.filePath.substring(process.env.VUE_APP_IMG_BASEURL.length),
        fileThumPath: item.fileThumPath.substring(process.env.VUE_APP_IMG_BASEURL.length),
        fileType: item.fileType,
      })
    })
    return list
  },
  // 转换其他附件
  covertOther(list, dataList) {
    dataList.forEach(item => {
      const url = item.url.substring(process.env.VUE_APP_IMG_BASEURL.length)
      list.push({
        fileId: item.fileId, // 附件id，用于删除附件AP
        fileName: item.name,
        filePath: url,
        fileThumPath: url,
        fileType: 'other',
      })
    })
    return list
  },

  // 初始化时将整个list转换成对应得视频、图片和其他附件
  initData(list) {
    const video = []
    const img = []
    const file = []
    list.forEach(item => {
      switch (item.fileType) {
        case 'video':
          video.push({
            fileId: item.fileId,
            fileName: item.fileName,
            filePath: process.env.VUE_APP_IMG_BASEURL + item.filePath,
            fileThumPath: process.env.VUE_APP_IMG_BASEURL + item.fileThumPath,
            fileType: item.fileType,
          })
          break
        case 'image': {
          img.push({
            uid: item.fileId,
            name: item.fileName,
            url: process.env.VUE_APP_IMG_BASEURL + item.fileThumPath,
            status: 'success',
            fileId: item.fileId,
            filePath: process.env.VUE_APP_IMG_BASEURL + item.filePath,
            fileThumPath: process.env.VUE_APP_IMG_BASEURL + item.fileThumPath,
            fileType: item.fileType
          })
          break;
        }
        case 'other':
          file.push({
            fileId: item.fileId,
            name: item.fileName,
            url: process.env.VUE_APP_IMG_BASEURL + item.filePath,
            fileType: item.fileType,
          })
          break
        default:
          break
      }
    })

    return {
      video,
      img,
      file
    }
  }
}

export default tool;
